export default __webpack_public_path__ + "static/media/logo.2bf037be.png";